import { render, staticRenderFns } from "./ReReviewPage.vue?vue&type=template&id=f3dde3e4&scoped=true"
import script from "./ReReviewPage.vue?vue&type=script&lang=js"
export * from "./ReReviewPage.vue?vue&type=script&lang=js"
import style0 from "./ReReviewPage.vue?vue&type=style&index=0&id=f3dde3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_abc276eb37b0b1314bfe9ec856cc5e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dde3e4",
  null
  
)

export default component.exports